export default __webpack_public_path__ + "static/memeGenerator-c62c75024189d98c8b464e0f342b8b5a.png";